import Vue from 'vue';
import Modules from '@app/modules';
import NavigationComponent from '@app/components/Navigation.vue';
import FooterComponent from '@app/components/Footer.vue';
import CookieConsentComponent from '@app/components/CookieConsent.vue';
import ModalComponent from '@app/components/Modal.vue';
export default Vue.extend({
    components: {
        NavigationComponent: NavigationComponent,
        FooterComponent: FooterComponent,
        ModalComponent: ModalComponent,
        CookieConsentComponent: CookieConsentComponent,
    },
    data: function () {
        return {
            modal: {
                isOpen: false,
                component: null
            },
            appModuleComponents: Modules.getTaggedComponents('app')
        };
    },
    created: function () {
        var _this = this;
        this.$store.ACTIONS.loadRoutesData();
        this.$store.MUTATIONS.setLocale(this.$helpers.locale() || 'de');
        this.$root.$on('modal-open', function (e) {
            _this.modal.component = e;
            setTimeout(function () { return _this.modal.isOpen = true; }, 50);
        });
    },
    computed: {
        showCookieConsent: function () {
            return window.COOKIE_CONSENT;
        }
    }
});
